import React from "react";

const Footer = () => {
  return (
    <>
      <div className="inner">
        <div className="copy">
          <p>
            &copy; {new Date().getFullYear()}{" "}
            <a
              href="mailto:hello@przemyslawkasiura.pl"
              target="_blank"
              rel="noreferrer"
            >
              Przemysław Kasiura
            </a>
            . Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
